import _       from 'lodash'
import request from 'request-promise'

import { NotFoundError, BadRequestError, ForbiddenError, PreconditionFailed } from 'lib/errors'
export { NotFoundError, BadRequestError, ForbiddenError, PreconditionFailed }

export default class Backend
  @forceLogging = false

  # expects auth to have .token attribute/property
  constructor: (@baseUrl, @auth) ->

  @request: (method, url, options = {}, resourceName = 'resource', logging = false) ->
    if logging or @forceLogging
      console.log("#{method} #{url}")
      console.log(JSON.stringify(options))

    options = _.assign({}, options, { uri: url, method: method, json: true })

    request(options).catch (response) => @_failureProcessor(response, resourceName)

  @requestWithAuth: (authToken, method, url, options = {}, resourceName = 'resource', logging = false) ->
    options.headers ?= {}
    options.headers['Authorization'] = "Token #{authToken}"

    @request(method, url, options, resourceName, logging)

  # TODO: replace this using request qs option
  @pairsToParams: (pairs) ->
    pairs.map((pair) -> pair.join('=')).join('&')

  @withParams: (url, params...) ->
    joined = _.concat(params...)

    if joined.length then url + '?' + @pairsToParams(joined) else url

  @_failureProcessor: (response, resourceName) ->
    if response.statusCode == 400
      throw new BadRequestError(response.error)
    if response.statusCode == 403
      throw new ForbiddenError(response.error)
    if response.statusCode == 404
      throw new NotFoundError(resourceName)
    if response.statusCode == 412
      throw new PreconditionFailed(response.error)
    else
      throw response

  request: (method, path, args...) ->
    @constructor.request(method, @baseUrl + path, args...)

  requestWithAuth: (method, path, args...) ->
    @constructor.requestWithAuth(@auth.token, method, @baseUrl + path, args...)

  requestWithToken: (token, method, path, args...) ->
    @constructor.requestWithAuth(token, method, @baseUrl + path, args...)
